var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg404Img = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 120,
  height: 101
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "404_img_svg__a",
  d: "M3.606.193v1.263H.156V.193h3.45z"
}), /*#__PURE__*/React.createElement("path", {
  id: "404_img_svg__c",
  d: "M3.606.193v1.263H.156V.193h3.45z"
}), /*#__PURE__*/React.createElement("path", {
  id: "404_img_svg__e",
  d: "M2.503.204v5.215H.178V.204h2.325z"
}), /*#__PURE__*/React.createElement("path", {
  id: "404_img_svg__g",
  d: "M0 .204v5.215h2.325V.204H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#979797",
  d: "M52.528 35.294C46.71 38.213 44.771 42.71 41.565 45.5c-2.962 2.58-12.65-3.84-12.65-3.84s-3.634-3.132-3.984-1.895c-.096.342.794 1.257 0 1.896-2.076 1.671-1.63-1.016-5.53 1.213 2.798 2.682 7.827 2.626 7.827 2.626s7.437 4.72 14.337 5.534c4.431-3.405 2.123-2.098 6.33-6.638v34.366h23.032c.71-10.747.26-23.499.26-32.925 2.959 3.295 5.34 3.364 5.34 3.364s12.648-5.046 12.963-4.267c.175.431 3.811 4.267 5.225 1.199.746.493-4.503-2.493-2.23-2.784 2.974-1.318-2.714-1.688-2.714-1.688s-8.351 1.571-13.245 3.273c-5.001-6.333-5.091-9.64-10.134-9.64H52.528zm.436 43.698V94.15s-3.337 0-6.187 4.616c4.446 0 10.695-.154 10.695-.154l.102-19.62h-4.61zm12.709 0V94.15s3.336 0 6.187 4.616c-4.446 0-10.695-.154-10.695-.154l-.102-19.62h4.61z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#979797",
  d: "M61.611 35.294s0 22.903-13.994 24.679m18.62-24.679s-1.275 5.758 4.09 10.382"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7921C",
  stroke: "#979797",
  d: "M61.565 35.312s-.448 23.094-13.684 24.802V78.66c9.25.014 23.275.014 23.275.014V45.538c-6.12-3.592-5.095-10.226-5.095-10.226h-4.496z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58.121,
  cy: 71.849,
  r: 3.782,
  fill: "#515151",
  stroke: "#979797"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#515151",
  stroke: "#979797",
  d: "M53.875 57.825s3.261 10.993-5.83 8.462v-5.945c3.189-1.273 5.83-2.517 5.83-2.517z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61.063,
  cy: 61.345,
  r: 2.521,
  fill: "#515151",
  stroke: "#979797"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66.105,
  cy: 47.059,
  r: 1.681,
  fill: "#515151",
  stroke: "#979797"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#515151",
  stroke: "#979797",
  d: "M71.02 49.248s-9.68 7.192 0 13.074V49.248z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6EB26",
  d: "M25.858 66.947a.63.63 0 0 1-.63-.631v-2.193a.63.63 0 1 1 1.26 0v2.193a.63.63 0 0 1-.63.631m-3.218 1.335a.628.628 0 0 1-.446-.185l-1.548-1.55a.63.63 0 1 1 .891-.893l1.548 1.55a.632.632 0 0 1-.445 1.078m-1.333 3.223h-2.19a.63.63 0 0 1 0-1.262h2.19a.63.63 0 0 1 0 1.262m-.215 4.773a.632.632 0 0 1-.446-1.078l1.548-1.55a.632.632 0 0 1 .891.893l-1.548 1.55a.627.627 0 0 1-.445.185m4.766 1.978a.63.63 0 0 1-.63-.632v-2.192a.63.63 0 1 1 1.26 0v2.192a.63.63 0 0 1-.63.632m4.765-1.978a.628.628 0 0 1-.445-.185l-1.548-1.55a.632.632 0 0 1 .891-.892l1.548 1.55a.632.632 0 0 1-.446 1.077"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(29.622 70.05)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "404_img_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#404_img_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E6EB26",
  d: "M2.976 1.456H.786a.63.63 0 0 1 0-1.263h2.19a.63.63 0 0 1 0 1.263",
  mask: "url(#404_img_svg__b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E6EB26",
  d: "M29.076 68.282a.632.632 0 0 1-.446-1.078l1.548-1.55a.632.632 0 0 1 .891.893l-1.548 1.55a.627.627 0 0 1-.445.185"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9893B",
  d: "M99.807 24.09a.63.63 0 0 1-.63-.631v-2.193a.63.63 0 1 1 1.26 0v2.193a.63.63 0 0 1-.63.63m-3.217 1.336a.628.628 0 0 1-.446-.185l-1.548-1.55a.63.63 0 1 1 .891-.893l1.548 1.55a.632.632 0 0 1-.446 1.078m-1.333 3.223h-2.189a.63.63 0 0 1 0-1.262h2.19a.63.63 0 0 1 0 1.262m-.216 4.773a.632.632 0 0 1-.446-1.078l1.549-1.55a.632.632 0 0 1 .891.893l-1.548 1.55a.627.627 0 0 1-.446.185m4.766 1.977a.63.63 0 0 1-.63-.63v-2.193a.63.63 0 1 1 1.26 0v2.192a.63.63 0 0 1-.63.631m4.766-1.977a.628.628 0 0 1-.446-.185l-1.547-1.55a.632.632 0 0 1 .89-.893l1.549 1.55a.632.632 0 0 1-.446 1.078"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(103.571 27.192)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "404_img_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#404_img_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F9893B",
  d: "M2.976 1.456H.786a.63.63 0 0 1 0-1.263h2.19a.63.63 0 0 1 0 1.263",
  mask: "url(#404_img_svg__d)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F9893B",
  d: "M103.025 25.425a.632.632 0 0 1-.446-1.078l1.549-1.55a.632.632 0 0 1 .891.893l-1.548 1.55a.627.627 0 0 1-.446.185"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.936 59.757h3.735m-1.868-1.867v3.735M55.185 2.179h3.736M57.053.311v3.735",
  stroke: "#979797",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 36.277,
  cy: 18.332,
  fill: "#EB26AA",
  rx: 3.113,
  ry: 3.112
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 86.273,
  cy: 11.111,
  fill: "#EBA826",
  rx: 3.729,
  ry: 3.735
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#979797",
  strokeLinecap: "square",
  d: "M.42 98.74h117.647"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5D4C3",
  d: "M68.418 21.781s3.627 1.727 0 4.456"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(67.973 21.175)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "404_img_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#404_img_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "m.712 5.419-.534-.713c.696-.524 1.51-1.319 1.429-2.129C1.512 1.632.267 1.015.254 1.01L.636.204c.07.033 1.71.83 1.856 2.284.099.982-.5 1.968-1.78 2.93",
  mask: "url(#404_img_svg__f)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E5D4C3",
  d: "M49.116 26.237c-3.628-2.73 0-4.456 0-4.456"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.059 21.175)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "404_img_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#404_img_svg__g"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M1.79 5.419C.51 4.456-.088 3.47.01 2.489.156 1.033 1.797.236 1.866.203l.383.805c-.012.006-1.26.617-1.353 1.571-.08.809.733 1.603 1.429 2.126l-.535.713z",
  mask: "url(#404_img_svg__h)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M59.518 12.72h-1.057c-4.884 0-8.856 3.978-8.856 8.869v8.492c0 4.669 3.792 8.467 8.454 8.467h1.46c4.661 0 8.454-3.798 8.454-8.467v-8.894c0-4.67-3.793-8.467-8.455-8.467"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M68.418 30.08c0 4.903-4.005 8.914-8.9 8.914H58.06c-4.895 0-8.9-4.011-8.9-8.913v-8.492c0-5.123 4.185-9.315 9.3-9.315h1.058c4.895 0 8.9 4.011 8.9 8.913v8.894zm-8.9-18.251h-1.057c-5.374 0-9.746 4.378-9.746 9.76v8.492c0 5.16 4.192 9.358 9.345 9.358h1.458c5.152 0 9.345-4.198 9.345-9.358v-8.894c0-5.16-4.193-9.358-9.345-9.358z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M67.973 30.081c0 4.669-3.793 8.467-8.455 8.467H58.06c-4.662 0-8.454-3.798-8.454-8.467v-8.492c0-4.89 3.972-8.869 8.856-8.869h1.057c4.662 0 8.455 3.798 8.455 8.467v8.894zm-8.455-17.807h-1.057c-5.116 0-9.301 4.192-9.301 9.315v8.492c0 4.902 4.005 8.913 8.9 8.913h1.458c4.895 0 8.9-4.011 8.9-8.913v-8.894c0-4.902-4.005-8.913-8.9-8.913z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M56.091 24.087a.921.921 0 0 1-1.118 1.12.921.921 0 0 1 .457-1.783.913.913 0 0 1 .661.663m7.176 0a.921.921 0 0 1-1.12 1.12.921.921 0 0 1 .457-1.783.913.913 0 0 1 .663.663m-4.713 5.456a.44.44 0 0 1-.287-.106c-.5-.425-.735-.883-.697-1.36.055-.7.683-1.1.754-1.143a.446.446 0 0 1 .464.76c-.082.052-.316.245-.332.456-.015.218.202.45.387.607a.447.447 0 0 1-.289.786"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0C1C1",
  d: "M55.893 28.577c0 .534-1.02.966-2.28.966-1.26 0-2.28-.432-2.28-.966 0-.533 1.02-.965 2.28-.965 1.26 0 2.28.432 2.28.965m10.309 0c0 .534-1.02.966-2.28.966-1.26 0-2.281-.432-2.281-.966 0-.533 1.021-.965 2.28-.965 1.26 0 2.28.432 2.28.965"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#979797",
  d: "M68.418 21.48c-2.968.167-6.96-6.044-6.96-6.044-2.25 5.124-12.298 6.153-12.298 6.153s-2.505-10.86 9.793-10.61c12.349.251 9.465 10.5 9.465 10.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M58.54 11.421c-3.514 0-6.057.959-7.562 2.849-1.913 2.404-1.625 5.698-1.455 6.824 1.88-.26 9.659-1.58 11.529-5.837a.445.445 0 0 1 .78-.062c1.01 1.569 4.026 5.555 6.234 5.828.202-1.011.624-4.094-1.134-6.463-1.486-2.003-4.174-3.057-7.988-3.135a18.32 18.32 0 0 0-.404-.004m-9.38 10.614a.445.445 0 0 1-.434-.346c-.044-.19-1.044-4.701 1.551-7.969 1.744-2.195 4.648-3.266 8.686-3.186 4.107.084 7.03 1.261 8.688 3.501 2.38 3.216 1.244 7.39 1.195 7.566a.445.445 0 0 1-.404.324c-2.614.141-5.798-4-6.933-5.622-2.841 4.708-11.902 5.688-12.304 5.73a.516.516 0 0 1-.046.002"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M53.167 23.842a.446.446 0 0 1-.406-.627c.326-.733 1.512-1.936 3.659-1.246a.446.446 0 0 1-.272.85c-1.936-.624-2.548.702-2.574.759a.444.444 0 0 1-.407.264m11.127 0a.445.445 0 0 1-.406-.262c-.067-.144-.7-1.365-2.575-.762a.446.446 0 0 1-.272-.849c2.15-.69 3.333.513 3.659 1.246a.446.446 0 0 1-.406.627"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#979797",
  stroke: "#757575",
  d: "M49.378 30.022c.417 3.068 2.96 5.203 3.834 2.424.876-2.78 9.117-4.158 12.113 0 1.556 2.16 3.114 0 3.114-2.424 4.356 1.745-1.09 14.746-10.816 13.33-.516.659.018 1.285-.742 1.416-.76.132-1.826-.774-3.285-2.793-.388-.536-.74 2.933-.874 2.793-.076-.079-2.838-3.197-1.878-4.673-2.692-3.271-3.304-7.836-1.466-10.073z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M58.816 34.454c-1.626 0-2.785-.417-2.857-.444a.42.42 0 0 1-.255-.55.45.45 0 0 1 .575-.245c.024.009 2.415.86 5.035-.005a.45.45 0 0 1 .566.264.422.422 0 0 1-.276.541 8.897 8.897 0 0 1-2.788.439m1.164 1.731h-2.392a.445.445 0 0 1 0-.89h2.392a.445.445 0 0 1 0 .89"
}))));
export default Svg404Img;